import { Injectable } from '@angular/core';
import { MessageService, ToastMessageOptions } from 'primeng/api';
import { Observable } from 'rxjs';
import * as fromDataServices from '../../data-services';
import { Toast, ToastType } from '../../data-services/toaster/toast.model';
import { Guid } from '../../shared';

@Injectable({
    providedIn: 'root'
})
export class ToasterService {
    constructor(private _toaster: MessageService) {}
    addToast: Observable<fromDataServices.Toaster.Toast>;
    clearToasts: Observable<fromDataServices.Toaster.IClearWrapper>;
    removeToast: Observable<fromDataServices.Toaster.IClearWrapper>;

    /**
     * Synchronously create and show a new toast instance.
     *
     * @param {(string | Toast)} type The type of the toast, or a Toast object.
     * @param {string=} title The toast title.
     * @param {string=} body The toast body.
     * @returns {Toast}
     *          The newly created Toast instance with a randomly generated GUID Id.
     */
    pop(
        type: string | Partial<Toast>,
        title?: string,
        body?: string,
        key?: string
    ): Toast {
        let msg: ToastMessageOptions;
        if (typeof type === 'string') {
            msg = {
                severity: type,
                summary: title,
                detail: body,
                closable: true,
                life: 5000,
                key: key ?? 'ef-global-toast'
            } as ToastMessageOptions;
        } else {
            msg = type as ToastMessageOptions;
            msg = {
                ...type,
                summary: type.title,
                detail: type.body,
                severity: type.type,
                key: type.toastContainerId ?? 'ef-global-toast',
                life: type.timeout ?? 5000,
                sticky: type.sticky ?? false
            };
        }
        this._toaster.add(msg);
        return {
            ...msg,
            type: msg.severity as ToastType,
            id: Guid.newGuid().toString()
        };
    }
    /**
     * Clears a toast by toastId and/or toastContainerId.
     *
     * @param {string} key The key of the container to remove toasts from.
     */
    clear(key?: string): void {
        this._toaster.clear(key ?? 'ef-global-toast');
    }
}
